export const HANDLE_CHANGE_RP_INPUT = 'HANDLE_CHANGE_RP_INPUT';
export function handleChangeInput (changedData) {
  return {
    type: HANDLE_CHANGE_RP_INPUT,
    payload: {
      changedData,
    },
  };
}

import { POST_API } from 'middlewares/form';
import LGTM from 'lgtm';

function getRequiredCustomFields (customFields) {
  return Object.keys(customFields).filter(f => customFields[f].required);
}

export const HANDLE_SUBMIT_REFINE_PURCHASE_REQUEST = 'HANDLE_SUBMIT_REFINE_PURCHASE_REQUEST';
export const HANDLE_SUBMIT_REFINE_PURCHASE_SUCCESS = 'HANDLE_SUBMIT_REFINE_PURCHASE_SUCCESS';
export const HANDLE_SUBMIT_REFINE_PURCHASE_FAILURE = 'HANDLE_SUBMIT_REFINE_PURCHASE_FAILURE';
import { mapPayloadForServer } from '../utils/InitializePurchaseUtils';
import { getOrderEndpoint } from '../utils/GlobalUtils';
import undoCasingCustomFieldsErrors from './refine/undoCasingCustomFieldsErrors';
import { storeFinalPayload } from './FinalizePurchaseActions';
let finalPayload;

export const refinePurchaseValidator = ({
  store, initialValidator: validator, includeShipping,
}) => {
  if (!validator) {
    validator = LGTM.validator();
  }

  const { customFields = {} } = store.refinePurchase.offer;

  getRequiredCustomFields(customFields).forEach(customField => {
    if (!includeShipping && customFields[customField].isShippingField) {
      return;
    }

    validator = validator
      .validates(customField)
      .required(customFields[customField].validationMessage || 'This field is required');

    if (customFields[customField].type === 'bool') {
      // this is a single tick checkbox - it HAS to be checked as it's required
      validator.using(value => value, 'This field is required');
    }
    if (customFields[customField].hasCustomValidation && customFields[customField].customValidation && customFields[customField].customValidationMessage) {
      //This adds the custom validation
      validator.using( (value) => customFields[customField].customValidation(value), customFields[customField].customValidationMessage);
    }
  });

  return validator.build();
};

export const refinePurchaseToValidate = ({
  store, includeShipping,
}) => {
  const { customFields = {} } = store.refinePurchase.offer;
  const { customFields: customFieldsForm } = store.refinePurchase.form;

  return getRequiredCustomFields(customFields).reduce((toValidate, field) => {
    if (!includeShipping && customFields[field].isShippingField) {
      return toValidate;
    }
    toValidate[field] = customFieldsForm[field];
    return toValidate;
  }, {});
};

export const refinePurchasePayload = ({ store, includeShipping }) => {
  const { customFields, socialpayPlatforms } = store.refinePurchase.offer;
  const { customFields: customFieldsForm, selectedSocialPayPlatform } = store.refinePurchase.form;
  const customFieldsPayload = Object.keys(customFields).reduce((payload, customField) => {
    if (!includeShipping && customFields[customField].isShippingField) {
      return payload;
    }
    payload[customField] = customFieldsForm[customField];
    if (customFields[customField].type === 'bool') {
      // the validator will ensure it's checked. Hence, not checking the actual form value
      payload[customField] = 'on';
    }
    return payload;
  }, {});

  finalPayload = {
    ...store.refinePurchase.initialPayload,
    ...customFieldsPayload,
  };

  if (socialpayPlatforms) {
    finalPayload = {
      ...finalPayload,
      platform: selectedSocialPayPlatform,
    };
  }

  return mapPayloadForServer(finalPayload);
};

export const handleSubmitRefinePurchase = () => ({
  [POST_API]: {
    types: [HANDLE_SUBMIT_REFINE_PURCHASE_REQUEST, HANDLE_SUBMIT_REFINE_PURCHASE_SUCCESS, HANDLE_SUBMIT_REFINE_PURCHASE_FAILURE],
    endpoint: getOrderEndpoint(),
    validator: (store) => refinePurchaseValidator({
      store, includeShipping: true,
    }),
    toValidate: (store) => refinePurchaseToValidate({
      store, includeShipping: true,
    }),
    failureActionErrors: (response) => {
      const { errors } = response;
      /**
       * the keys sent from the backend will be camelCased by the middleware
       * since we have hardcoded the shipping keys to be snakeCased in the reducer,
       * need to make an exception here for shipping fields
       */
      return undoCasingCustomFieldsErrors({ errors });
    },
    payloadAsIs: true,
    payload: store => refinePurchasePayload({
      store,
      includeShipping: true,
    }),
    onSuccess: (response, store, dispatch) => {
      dispatch(storeFinalPayload(finalPayload));
    },
  },
});

export const STORE_INITIAL_PAYLOAD = 'STORE_INITIAL_PAYLOAD';
export function storeInitialPayload (initialPayload) {
  return {
    type: STORE_INITIAL_PAYLOAD,
    payload: {
      initialPayload,
    },
  };
}

import { handleSetSocialPayPlatform, handleSetupSocialPayAuthCallbackListener } from './SocialPayActions';
export function handleSetSocialPayPlatformAndSubmitForm (platform) {
  return dispatch => {
    dispatch(handleSetSocialPayPlatform(platform));
    dispatch(handleSubmitRefinePurchase());
    dispatch(handleSetupSocialPayAuthCallbackListener());
  };
}



// WEBPACK FOOTER //
// ./src/payments/actions/RefinePurchaseActions.js